import { render, staticRenderFns } from "./ossUpload.vue?vue&type=template&id=7aecd4ec&scoped=true&"
import script from "./ossUpload.vue?vue&type=script&lang=js&"
export * from "./ossUpload.vue?vue&type=script&lang=js&"
import style0 from "./ossUpload.vue?vue&type=style&index=0&id=7aecd4ec&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aecd4ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aecd4ec')) {
      api.createRecord('7aecd4ec', component.options)
    } else {
      api.reload('7aecd4ec', component.options)
    }
    module.hot.accept("./ossUpload.vue?vue&type=template&id=7aecd4ec&scoped=true&", function () {
      api.rerender('7aecd4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/common/ossUpload.vue"
export default component.exports